import { Endpoint } from '../endpoint';
import { SettingFieldResponse, FieldId } from '@business/entities/settingFields';

export function createCustomField(field: Partial<SettingFieldResponse>) {
  return Endpoint.post<SettingFieldResponse>(`@gc/fields/create`, { data: { ...field } });
}

export function updateCustomField(id: FieldId, field: Partial<SettingFieldResponse>) {
  return Endpoint.patch<SettingFieldResponse>(`@gc/fields/${id}`, { data: { ...field } });
}

export function sortCustomField(ids: FieldId[]) {
  return Endpoint.post<SettingFieldResponse>(`@gc/fields/sort`, { data: { ids } });
}

export function deleteCustomField(FieldId: FieldId) {
  return Endpoint.delete<void>(`@gc/fields/${FieldId}`);
}
